/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import Select from 'react-select';
import CreatableSelect from 'react-select';

const SDUserSelect = ({ initialValue, onUpdate, users, hasInitialOption, quickLinkShow, quickLinkId, quickLinkText }) => {
    const [selectedValue, setSelectedValue] = useState(initialValue);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        let o = []
        if (hasInitialOption) {
            o.push({ label: 'Unassigned', value: 0 });
        }

        users.map((user) => {
            let name = user.displayName != user.email ? `${user.displayName} (${user.email})` : `${user.email}`
            o.push({ label: name, value: user.id });
        });

        setOptions(o);
        console.log(o);
    }, []);

    const handleChange = (selectedOption) => {
        const newValue = selectedOption?.value || null
        setSelectedValue(newValue);
        console.log("Value changed!!", newValue);
        onUpdate(newValue);
    };


    return (
        <><Select options={options} isSearchable value={options.find(opt => opt.value === selectedValue)} onChange={handleChange} />
            {/* <Form.Select aria-label="Default select example" value={selectedValue} onChange={handleChange}>
                {hasInitialOption ? <option value={0}>Unassigned</option> : <></>}
                {users.map((user) => (
                    <option key={user.id} value={user.id}>
                        {user.displayName} {user.displayName != user.email ? `(${user.email})` : ``}
                    </option>
                ))}

            </Form.Select> */}
            {quickLinkShow == true ?
                <div className="d-flex justify-content-end align-items-center">
                    <a href='#' onClick={() => {
                        setSelectedValue(quickLinkId);
                        onUpdate(quickLinkId);
                    }}>{quickLinkText}</a>
                </div> : <></>}
        </>
    );
}

export default SDUserSelect;
